<template>
  <div>
    <!-- 根据 id 渲染加载001/index.vue、002/index.vue组件 -->
    <component :is="currentComponent" v-if="currentComponent" />
  </div>
</template>

<script>
const components = {}

let vipHdTotal=2;//注：新增002目录,改值为：2，依此类推
for (let i = 1; i <=vipHdTotal; i++) {
  const key=`00${i}`.slice(-3) //保证三位数，如 001, 002
  components[key] = () => import(`./${key}/index.vue`);
  
}
// console.log(components)

export default {
  props: ['id'],
  computed: {
    currentComponent() {
      return components[this.id] || null
    }
  },
  watch: {
    id: {
      handler(newId) {

      },
      immediate: true
    }
  },
  created() {
    const id=Number(this.$route.params?.id)
    if(id>vipHdTotal){
      // this.$layer.msg('访问路径不正确！')
      this.$message({
          message: '访问路径不正确！',
          type: 'error',
          duration: 5000
      })
      this.$router.push({
        name:'error'
      })
    }
  },
  mounted() {
     
  },
}
</script>